import styled from "styled-components";

const QuestionCircle = styled.i.attrs({
  className: "fa fa-question-circle"
})``;

export default QuestionCircle;



// WEBPACK FOOTER //
// ./src/components/icons/QuestionCircle.js